import React, { Component } from 'react';
import { connect }          from 'react-redux';
import moment               from 'moment';
import { Redirect }         from 'react-router'
import { SetError }         from '../actions/authenticActions';
import { SetStatusTalentos,
		 SetStatusAcessoDiario } from  '../actions/notificacaoAction';

export default function(ComposeComponent){

    class Authenticate extends Component {

		constructor(props){
			super(props)
			this.state = {
		     acesso:false
			}
		}

		componentWillMount(){

			const horaToken = moment.unix(this.props.user.exp).format("HH:mm a");
			const horaAtual = moment().format('HH:mm a');
			const dataToken = this.props.user.data;
			const dataDia   = moment().format("DD/MM/YYYY");

			if(this.props.session){
			  if(horaAtual>horaToken && dataToken!==dataDia){
    		    this.props.SetError({});
		      }
			}
			
			if(!this.props.isAuthenticated){
			  this.setState({acesso:true})
			  this.props.SetError({});
			}
			
		}

		
        render() {
			
		
				
			if(this.props.match.path === '/login' && this.props.isAuthenticated === true){
				return (<Redirect to={'/home'}/>);
			}

			if (this.state.acesso) {
				 return (<Redirect to={'/login'}/>);
			}
		
			return (
				<ComposeComponent {...this.props}/>
			);
		}
	}


function mapStateToProps(state){

    return {
             isAuthenticated : state.auth.isAuthenticated,
             sesison         : state.auth.session,
			 user            : state.auth.user
           };
}
	
	return connect(mapStateToProps,{ SetStatusTalentos,SetStatusAcessoDiario,SetError })(Authenticate);

}


// WEBPACK FOOTER //
// ./src/utils/requireAuthenticate.js